import LangEnum from '../../../../lang/LangEnum';

export enum ActionEnum {
  ARCHIVE_ORDER = 'ARCHIVE_ORDER',
  AUTHORIZE_ORDER_PAYMENT = 'AUTHORIZE_ORDER_PAYMENT',
  BACK_TO_APPROVED = 'BACK_TO_APPROVED',
  BACK_TO_DRAFT = 'BACK_TO_DRAFT',
  BACK_TO_IN_REVISION = 'BACK_TO_IN_REVISION',
  BACK_TO_ON_APPROVAL = 'BACK_TO_ON_APPROVAL',
  CONFIRM_BACK_TO_DRAFT = 'CONFIRM_BACK_TO_DRAFT',
  COPY_AS_DRAFT = 'COPY_AS_DRAFT',
  COPY_AS_SUGGESTED = 'COPY_AS_SUGGESTED',
  CHECK_ORDER_INTEGRATION = 'CHECK_ORDER_INTEGRATION',
  DOWNLOAD_MEDIAS = 'DOWNLOAD_MEDIAS',
  EXPORT_ORDER = 'EXPORT_ORDER',
  FORCE_REVERSE_SYNC_ORDER = 'FORCE_REVERSE_SYNC_ORDER',
  FORCE_SYNC_ORDER = 'FORCE_SYNC_ORDER',
  FINISH_TO_APPROVED = 'FINISH_TO_APPROVED',
  FINISH_TO_IN_REVISION = 'FINISH_TO_IN_REVISION',
  FINISH_TO_ON_APPROVAL = 'FINISH_TO_ON_APPROVAL',
  MOVE_TO_CANCELED = 'MOVE_TO_CANCELED',
  MOVE_TO_SENT = 'MOVE_TO_SENT',
  MOVE_TO_REJECTED = 'MOVE_TO_REJECTED',
  OPEN_CONTRACT_MODAL = 'OPEN_CONTRACT_MODAL',
  OPEN_SIGN_ORDER_MODAL = 'OPEN_SIGN_ORDER_MODAL',
  OPEN_ORDER_HISTORIC_MODAL = 'OPEN_ORDER_HISTORIC_MODAL',
  OPEN_ORDER_PAYMENT_HISTORY_MODAL = 'OPEN_ORDER_PAYMENT_HISTORY_MODAL',
  OPEN_ORDER_REFUND_PAYMENT_MODAL = 'OPEN_ORDER_REFUND_PAYMENT_MODAL',
  OPEN_CANCEL_PAYMENT_LINK_MODAL = 'OPEN_CANCEL_PAYMENT_LINK_MODAL',
  OPEN_ORDER_PAYMENT_MODAL = 'OPEN_ORDER_PAYMENT_MODAL',
  OPEN_ORDER_WAS_UPDATED_MODAL = 'OPEN_ORDER_WAS_UPDATED_MODAL',
  OPEN_OUTDATED_ORDER_MODAL = 'OPEN_OUTDATED_ORDER_MODAL',
  OPEN_UPDATE_ORDER_MODAL = 'OPEN_UPDATE_ORDER_MODAL',
  SHARE_ORDER = 'SHARE_ORDER',
  SPLIT_ORDER = 'SPLIT_ORDER',
  SYNC = 'SYNC',
  UNARCHIVE_ORDER = 'UNARCHIVE_ORDER',
  VALIDATE_OR_UPDATE_ORDER = 'VALIDATE_OR_UPDATE_ORDER',
  VERUP_EXPORT_CSV = 'VERUP_EXPORT_CSV',
  VIEW_CONTRACTS = 'VIEW_CONTRACTS',
  VIEW_ORDER_ACTIVITIES = 'VIEW_ORDER_ACTIVITIES',
  SYNC_OFFLINE_ORDER = 'SYNC_OFFLINE_ORDER',
  ACCEPT_SUGGESTION = 'ACCEPT_SUGGESTION',
  EXPORT_MULTIPLE_ORDERS = 'EXPORT_MULTIPLE_ORDERS',
}

export type CopyOrderActionType = ActionEnum.COPY_AS_DRAFT | ActionEnum.COPY_AS_SUGGESTED;

export interface OrderAction {
  icon: React.ReactNode;
  label: LangEnum;
  value: ActionEnum;
  testId?: string;
}
